import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Globe, Lock, Heart } from 'lucide-react';
const highlights = [{
  icon: <Globe className="w-5 h-5" data-id="element-32" />,
  text: '扎根新加坡，服务全球华人精英客户'
}, {
  icon: <Lock className="w-5 h-5" data-id="element-33" />,
  text: '端到端加密通讯，零数据泄露记录'
}, {
  icon: <Sparkles className="w-5 h-5" data-id="element-34" />,
  text: '每位伴游均通过三轮面试与背景审查'
}, {
  icon: <Heart className="w-5 h-5" data-id="element-35" />,
  text: '98% 客户满意度，超高复购率'
}];
export function AboutSection() {
  return <section className="py-24 bg-dark-surface relative overflow-hidden" data-id="element-36">
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gold-500/3 rounded-full blur-[150px] pointer-events-none" data-id="element-37" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-38">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-39">
          {/* Left — Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-40">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]" data-id="element-41">
              <img src="https://images.unsplash.com/photo-1470225620780-dba8ba36b745?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="SGLonelyGuy 高端社交场景" className="w-full h-full object-cover" data-id="element-42" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-43" />
              <div className="absolute bottom-8 left-8 right-8" data-id="element-44">
                <div className="text-gold-500 font-serif text-lg italic" data-id="element-45">
                  "让每一次相遇，都成为值得珍藏的回忆"
                </div>
              </div>
            </div>
            {/* Decorative border */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-gold-500/20 rounded-2xl -z-10" data-id="element-46" />
          </motion.div>

          {/* Right — Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-47">
            <span className="text-gold-500 uppercase tracking-[0.2em] text-sm font-medium" data-id="element-48">
              About Us
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-white mt-3 mb-6" data-id="element-49">
              关于<span className="text-gold-gradient" data-id="element-50"> 寂寞男人</span>
            </h2>

            <div className="space-y-5 text-gray-300 leading-relaxed" data-id="element-51">
              <p data-id="element-52">
                <strong className="text-white" data-id="element-53">
                  SGLonelyGuy（新加坡寂寞男人）
                </strong>
                创立于新加坡这座国际化大都市的核心地带。我们深知，在这座节奏飞快、竞争激烈的城市中，成功的都市精英们往往承受着巨大的压力，却鲜少有机会找到真正懂得倾听与陪伴的人。
              </p>
              <p data-id="element-54">
                正是基于这样的洞察，我们打造了一个
                <span className="text-gold-400" data-id="element-55">私密、安全、高品质</span>
                的社交伴游平台。SGLonelyGuy
                不仅仅是一个服务平台——它是一种生活方式的选择，是都市绅士们在繁忙工作之余，寻找温暖与陪伴的理想港湾。
              </p>
              <p data-id="element-56">
                我们的团队由资深行业专家组成，拥有超过
                <span className="text-white font-medium" data-id="element-57">十年</span>
                的高端社交服务经验。从伴游的严格筛选与培训，到客户隐私的全方位保护，再到每一次约会的精心安排，我们在每一个环节都追求极致。
              </p>
              <p data-id="element-58">
                无论您是在新加坡出差的商务人士，还是长期居住的本地精英，SGLonelyGuy
                都能为您匹配最合适的伴游伙伴，让您在这座城市中的每一个夜晚都充满温馨与精彩。
              </p>
            </div>

            {/* Highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10" data-id="element-59">
              {highlights.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4 + index * 0.1
            }} className="flex items-center gap-3 text-sm" data-id="element-60">
                  <div className="w-9 h-9 rounded-full bg-gold-500/10 border border-gold-500/20 flex items-center justify-center text-gold-500 flex-shrink-0" data-id="element-61">
                    {item.icon}
                  </div>
                  <span className="text-gray-300" data-id="element-62">{item.text}</span>
                </motion.div>)}
            </div>

            {/* Brand philosophy */}
            <div className="mt-10 p-6 bg-dark-bg/50 border border-white/5 rounded-xl" data-id="element-63">
              <h3 className="text-gold-500 font-serif text-lg mb-3" data-id="element-64">
                我们的理念
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-65">
                我们相信，真正的高端服务不在于奢华的表象，而在于对每一位客户需求的深度理解与尊重。SGLonelyGuy
                始终坚持"以人为本、隐私至上、品质为先"的服务宗旨，致力于成为新加坡乃至东南亚地区最值得信赖的伴游服务品牌。
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}